module.exports = __webpack_public_path__ + "static/media/icon-submit.db781b05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MessageForm/icon-submit.svg
// module id = 1105
// module chunks = 1